// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__dAQoI","file":"styles_file__2PJoK"};